export enum CountryCode {
  US = "US",
  CA = "CA",
  AF = "AF",
  AL = "AL",
  DZ = "DZ",
  AS = "AS",
  AD = "AD",
  AO = "AO",
  AI = "AI",
  AQ = "AQ",
  AG = "AG",
  AR = "AR",
  AM = "AM",
  AW = "AW",
  AU = "AU",
  AT = "AT",
  AZ = "AZ",
  BS = "BS",
  BH = "BH",
  BD = "BD",
  BB = "BB",
  BY = "BY",
  BE = "BE",
  BZ = "BZ",
  BJ = "BJ",
  BM = "BM",
  BT = "BT",
  BO = "BO",
  BQ = "BQ",
  BA = "BA",
  BW = "BW",
  BV = "BV",
  BR = "BR",
  IO = "IO",
  BN = "BN",
  BG = "BG",
  BF = "BF",
  BI = "BI",
  CV = "CV",
  KH = "KH",
  CM = "CM",
  KY = "KY",
  CF = "CF",
  TD = "TD",
  CL = "CL",
  CN = "CN",
  CX = "CX",
  CC = "CC",
  CO = "CO",
  KM = "KM",
  CD = "CD",
  CG = "CG",
  CK = "CK",
  CR = "CR",
  HR = "HR",
  CU = "CU",
  CW = "CW",
  CY = "CY",
  CZ = "CZ",
  CI = "CI",
  DK = "DK",
  DJ = "DJ",
  DM = "DM",
  DO = "DO",
  EC = "EC",
  EG = "EG",
  SV = "SV",
  GQ = "GQ",
  ER = "ER",
  EE = "EE",
  SZ = "SZ",
  ET = "ET",
  FK = "FK",
  FO = "FO",
  FJ = "FJ",
  FI = "FI",
  FR = "FR",
  GF = "GF",
  PF = "PF",
  TF = "TF",
  GA = "GA",
  GM = "GM",
  GE = "GE",
  DE = "DE",
  GH = "GH",
  GI = "GI",
  GR = "GR",
  GL = "GL",
  GD = "GD",
  GP = "GP",
  GU = "GU",
  GT = "GT",
  GG = "GG",
  GN = "GN",
  GW = "GW",
  GY = "GY",
  HT = "HT",
  HM = "HM",
  VA = "VA",
  HN = "HN",
  HK = "HK",
  HU = "HU",
  IS = "IS",
  IN = "IN",
  ID = "ID",
  IR = "IR",
  IQ = "IQ",
  IE = "IE",
  IM = "IM",
  IL = "IL",
  IT = "IT",
  JM = "JM",
  JP = "JP",
  JE = "JE",
  JO = "JO",
  KZ = "KZ",
  KE = "KE",
  KI = "KI",
  KP = "KP",
  KR = "KR",
  KW = "KW",
  KG = "KG",
  LA = "LA",
  LV = "LV",
  LB = "LB",
  LS = "LS",
  LR = "LR",
  LY = "LY",
  LI = "LI",
  LT = "LT",
  LU = "LU",
  MO = "MO",
  MG = "MG",
  MW = "MW",
  MY = "MY",
  MV = "MV",
  ML = "ML",
  MT = "MT",
  MH = "MH",
  MQ = "MQ",
  MR = "MR",
  MU = "MU",
  YT = "YT",
  MX = "MX",
  FM = "FM",
  MD = "MD",
  MC = "MC",
  MN = "MN",
  ME = "ME",
  MS = "MS",
  MA = "MA",
  MZ = "MZ",
  MM = "MM",
  NA = "NA",
  NR = "NR",
  NP = "NP",
  NL = "NL",
  NC = "NC",
  NZ = "NZ",
  NI = "NI",
  NE = "NE",
  NG = "NG",
  NU = "NU",
  NF = "NF",
  MP = "MP",
  NO = "NO",
  OM = "OM",
  PK = "PK",
  PW = "PW",
  PS = "PS",
  PA = "PA",
  PG = "PG",
  PY = "PY",
  PE = "PE",
  PH = "PH",
  PN = "PN",
  PL = "PL",
  PT = "PT",
  PR = "PR",
  QA = "QA",
  MK = "MK",
  RO = "RO",
  RU = "RU",
  RW = "RW",
  RE = "RE",
  BL = "BL",
  SH = "SH",
  KN = "KN",
  LC = "LC",
  MF = "MF",
  PM = "PM",
  VC = "VC",
  WS = "WS",
  SM = "SM",
  ST = "ST",
  SA = "SA",
  SN = "SN",
  RS = "RS",
  SC = "SC",
  SL = "SL",
  SG = "SG",
  SX = "SX",
  SK = "SK",
  SI = "SI",
  SB = "SB",
  SO = "SO",
  ZA = "ZA",
  GS = "GS",
  SS = "SS",
  ES = "ES",
  LK = "LK",
  SD = "SD",
  SR = "SR",
  SJ = "SJ",
  SE = "SE",
  CH = "CH",
  SY = "SY",
  TW = "TW",
  TJ = "TJ",
  TZ = "TZ",
  TH = "TH",
  TL = "TL",
  TG = "TG",
  TK = "TK",
  TO = "TO",
  TT = "TT",
  TN = "TN",
  TR = "TR",
  TM = "TM",
  TC = "TC",
  TV = "TV",
  UG = "UG",
  UA = "UA",
  AE = "AE",
  GB = "GB",
  UM = "UM",
  UY = "UY",
  UZ = "UZ",
  VU = "VU",
  VE = "VE",
  VN = "VN",
  VG = "VG",
  VI = "VI",
  WF = "WF",
  EH = "EH",
  YE = "YE",
  ZM = "ZM",
  ZW = "ZW",
  AX = "AX"
}
export enum CountryName {
  UnitedStates = "United States",
  USA = "USA",
  US = "US",
  Canada = "Canada",
  Afghanistan = "Afghanistan",
  Albania = "Albania",
  Algeria = "Algeria",
  AmericanSamoa = "American Samoa",
  Andorra = "Andorra",
  Angola = "Angola",
  Anguilla = "Anguilla",
  Antarctica = "Antarctica",
  AntiguaAndBarbuda = "Antigua and Barbuda",
  Argentina = "Argentina",
  Armenia = "Armenia",
  Aruba = "Aruba",
  Australia = "Australia",
  Austria = "Austria",
  Azerbaijan = "Azerbaijan",
  Bahamas = "Bahamas",
  Bahrain = "Bahrain",
  Bangladesh = "Bangladesh",
  Barbados = "Barbados",
  Belarus = "Belarus",
  Belgium = "Belgium",
  Belize = "Belize",
  Benin = "Benin",
  Bermuda = "Bermuda",
  Bhutan = "Bhutan",
  Bolivia = "Bolivia (Plurinational State of)",
  BonaireSintEustatiusAndSaba = "Bonaire, Sint Eustatius and Saba",
  BosniaAndHerzegovina = "Bosnia and Herzegovina",
  Botswana = "Botswana",
  BouvetIsland = "Bouvet Island",
  Brazil = "Brazil",
  BritishIndianOceanTerritoryThe = "British Indian Ocean Territory (the)",
  BritishIndianOceanTerritory = "British Indian Ocean Territory",
  BruneiDarussalam = "Brunei Darussalam",
  Bulgaria = "Bulgaria",
  BurkinaFaso = "Burkina Faso",
  Burundi = "Burundi",
  CaboVerde = "Cabo Verde",
  Cambodia = "Cambodia",
  Cameroon = "Cameroon",
  CaymanIslandsThe = "Cayman Islands (the)",
  CaymanIslands = "Cayman Islands",
  CentralAfricanRepublicThe = "Central African Republic (the)",
  CentralAfricanRepublic = "Central African Republic",
  Chad = "Chad",
  Chile = "Chile",
  China = "China",
  ChristmasIsland = "Christmas Island",
  CocosKeelingIslandsThe = "Cocos (Keeling) Islands (the)",
  CocosKeelingIslands = "Cocos (Keeling) Islands",
  Colombia = "Colombia",
  ComorosThe = "Comoros (the)",
  Comoros = "Comoros",
  CongoDemocraticRepublic = "Congo (the Democratic Republic of the)",
  Congo = "Congo (the)",
  CookIslandsThe = "Cook Islands (the)",
  CookIslands = "Cook Islands",
  CostaRica = "Costa Rica",
  Croatia = "Croatia",
  Cuba = "Cuba",
  Curacao = "Curaçao",
  Cyprus = "Cyprus",
  Czechia = "Czechia",
  CoteDIvoire = "Côte d'Ivoire",
  Denmark = "Denmark",
  Djibouti = "Djibouti",
  Dominica = "Dominica",
  DominicanRepublicThe = "Dominican Republic (the)",
  DominicanRepublic = "Dominican Republic",
  Ecuador = "Ecuador",
  Egypt = "Egypt",
  ElSalvador = "El Salvador",
  EquatorialGuinea = "Equatorial Guinea",
  Eritrea = "Eritrea",
  Estonia = "Estonia",
  Eswatini = "Eswatini",
  Ethiopia = "Ethiopia",
  FalklandIslands = "Falkland Islands (the) [Malvinas]",
  FaroeIslands = "Faroe Islands (the)",
  Fiji = "Fiji",
  Finland = "Finland",
  France = "France",
  FrenchGuiana = "French Guiana",
  FrenchPolynesia = "French Polynesia",
  FrenchSouthernTerritoriesThe = "French Southern Territories (the)",
  FrenchSouthernTerritories = "French Southern Territories",
  Gabon = "Gabon",
  GambiaThe = "Gambia (the)",
  Gambia = "Gambia",
  Georgia = "Georgia",
  Germany = "Germany",
  Ghana = "Ghana",
  Gibraltar = "Gibraltar",
  Greece = "Greece",
  Greenland = "Greenland",
  Grenada = "Grenada",
  Guadeloupe = "Guadeloupe",
  Guam = "Guam",
  Guatemala = "Guatemala",
  Guernsey = "Guernsey",
  Guinea = "Guinea",
  GuineaBissau = "Guinea-Bissau",
  Guyana = "Guyana",
  Haiti = "Haiti",
  HeardIslandAndMcDonaldIslands = "Heard Island and McDonald Islands",
  HolySeeThe = "Holy See (the)",
  HolySee = "Holy See",
  Honduras = "Honduras",
  HongKong = "Hong Kong",
  Hungary = "Hungary",
  Iceland = "Iceland",
  India = "India",
  Indonesia = "Indonesia",
  Iran = "Iran (Islamic Republic of)",
  Iraq = "Iraq",
  Ireland = "Ireland",
  IsleOfMan = "Isle of Man",
  Israel = "Israel",
  Italy = "Italy",
  Jamaica = "Jamaica",
  Japan = "Japan",
  Jersey = "Jersey",
  Jordan = "Jordan",
  Kazakhstan = "Kazakhstan",
  Kenya = "Kenya",
  Kiribati = "Kiribati",
  KoreaDemocraticPeoplesRepublic = "Korea (the Democratic People's Republic of)",
  KoreaRepublic = "Korea (the Republic of)",
  Kuwait = "Kuwait",
  Kyrgyzstan = "Kyrgyzstan",
  LaoPeoplesDemocraticRepublicThe = "Lao People's Democratic Republic (the)",
  LaoPeoplesDemocraticRepublic = "Lao People's Democratic Republic",
  Latvia = "Latvia",
  Lebanon = "Lebanon",
  Lesotho = "Lesotho",
  Liberia = "Liberia",
  Libya = "Libya",
  Liechtenstein = "Liechtenstein",
  Lithuania = "Lithuania",
  Luxembourg = "Luxembourg",
  Macao = "Macao",
  Madagascar = "Madagascar",
  Malawi = "Malawi",
  Malaysia = "Malaysia",
  Maldives = "Maldives",
  Mali = "Mali",
  Malta = "Malta",
  MarshallIslandsThe = "Marshall Islands (the)",
  MarshallIslands = "Marshall Islands",
  Martinique = "Martinique",
  Mauritania = "Mauritania",
  Mauritius = "Mauritius",
  Mayotte = "Mayotte",
  Mexico = "Mexico",
  Micronesia = "Micronesia (Federated States of)",
  Moldova = "Moldova (the Republic of)",
  Monaco = "Monaco",
  Mongolia = "Mongolia",
  Montenegro = "Montenegro",
  Montserrat = "Montserrat",
  Morocco = "Morocco",
  Mozambique = "Mozambique",
  Myanmar = "Myanmar",
  Namibia = "Namibia",
  Nauru = "Nauru",
  Nepal = "Nepal",
  NetherlandsThe = "Netherlands (the)",
  Netherlands = "Netherlands",
  NewCaledonia = "New Caledonia",
  NewZealand = "New Zealand",
  Nicaragua = "Nicaragua",
  Niger = "Niger (the)",
  Nigeria = "Nigeria",
  Niue = "Niue",
  NorfolkIsland = "Norfolk Island",
  NorthernMarianaIslandsThe = "Northern Mariana Islands (the)",
  NorthernMarianaIslands = "Northern Mariana Islands",
  Norway = "Norway",
  Oman = "Oman",
  Pakistan = "Pakistan",
  Palau = "Palau",
  PalestineState = "Palestine, State of",
  Panama = "Panama",
  PapuaNewGuinea = "Papua New Guinea",
  Paraguay = "Paraguay",
  Peru = "Peru",
  PhilippinesThe = "Philippines (the)",
  Philippines = "Philippines",
  Pitcairn = "Pitcairn",
  Poland = "Poland",
  Portugal = "Portugal",
  PuertoRico = "Puerto Rico",
  Qatar = "Qatar",
  RepublicOfNorthMacedonia = "Republic of North Macedonia",
  Romania = "Romania",
  RussianFederationThe = "Russian Federation (the)",
  RussianFederation = "Russian Federation",
  Rwanda = "Rwanda",
  Reunion = "Réunion",
  SaintBarthelemy = "Saint Barthélemy",
  SaintHelenaAscensionAndTristanDaCunha = "Saint Helena, Ascension and Tristan da Cunha",
  SaintKittsAndNevis = "Saint Kitts and Nevis",
  SaintLucia = "Saint Lucia",
  SaintMartinFrenchPart = "Saint Martin (French part)",
  SaintPierreAndMiquelon = "Saint Pierre and Miquelon",
  SaintVincentAndTheGrenadines = "Saint Vincent and the Grenadines",
  Samoa = "Samoa",
  SanMarino = "San Marino",
  SaoTomeAndPrincipe = "Sao Tome and Principe",
  SaudiArabia = "Saudi Arabia",
  Senegal = "Senegal",
  Serbia = "Serbia",
  Seychelles = "Seychelles",
  SierraLeone = "Sierra Leone",
  Singapore = "Singapore",
  SintMaartenDutchPart = "Sint Maarten (Dutch part)",
  Slovakia = "Slovakia",
  Slovenia = "Slovenia",
  SolomonIslands = "Solomon Islands",
  Somalia = "Somalia",
  SouthAfrica = "South Africa",
  SouthGeorgiaAndTheSouthSandwichIslands = "South Georgia and the South Sandwich Islands",
  SouthSudan = "South Sudan",
  Spain = "Spain",
  SriLanka = "Sri Lanka",
  SudanThe = "Sudan (the)",
  Sudan = "Sudan",
  Suriname = "Suriname",
  SvalbardAndJanMayen = "Svalbard and Jan Mayen",
  Sweden = "Sweden",
  Switzerland = "Switzerland",
  SyrianArabRepublic = "Syrian Arab Republic",
  Taiwan = "Taiwan",
  Tajikistan = "Tajikistan",
  Tanzania = "Tanzania, United Republic of",
  Thailand = "Thailand",
  TimorLeste = "Timor-Leste",
  Togo = "Togo",
  Tokelau = "Tokelau",
  Tonga = "Tonga",
  TrinidadAndTobago = "Trinidad and Tobago",
  Tunisia = "Tunisia",
  Turkey = "Turkey",
  Turkmenistan = "Turkmenistan",
  TurksAndCaicosIslands = "Turks and Caicos Islands (the)",
  TurksAndCaicosIslandsThe = "Turks and Caicos Islands",
  Tuvalu = "Tuvalu",
  Uganda = "Uganda",
  Ukraine = "Ukraine",
  UnitedArabEmirates = "United Arab Emirates (the)",
  UnitedKingdom = "United Kingdom of Great Britain and Northern Ireland (the)",
  UnitedStatesMinorOutlyingIslands = "United States Minor Outlying Islands (the)",
  UnitedStatesMinorOutlyingIslandsThe = "United States Minor Outlying Islands",
  Uruguay = "Uruguay",
  Uzbekistan = "Uzbekistan",
  Vanuatu = "Vanuatu",
  Venezuela = "Venezuela (Bolivarian Republic of)",
  VietNam = "Viet Nam",
  VirginIslandsBritish = "Virgin Islands (British)",
  VirginIslandsUS = "Virgin Islands (U.S.)",
  WallisAndFutuna = "Wallis and Futuna",
  WesternSahara = "Western Sahara",
  Yemen = "Yemen",
  Zambia = "Zambia",
  Zimbabwe = "Zimbabwe",
  AlandIslands = "Åland Islands"
}

export const CountryCodeMap = {
  [CountryCode.US]: { code: "US", code3: "USA", name: "USA", number: "840" },
  [CountryCode.CA]: { code: "CA", code3: "CAN", name: "Canada", number: "124" },
  [CountryCode.AF]: { code: "AF", code3: "AFG", name: "Afghanistan", number: "004" },
  [CountryCode.AL]: { code: "AL", code3: "ALB", name: "Albania", number: "008" },
  [CountryCode.DZ]: { code: "DZ", code3: "DZA", name: "Algeria", number: "012" },
  [CountryCode.AS]: { code: "AS", code3: "ASM", name: "American Samoa", number: "016" },
  [CountryCode.AD]: { code: "AD", code3: "AND", name: "Andorra", number: "020" },
  [CountryCode.AO]: { code: "AO", code3: "AGO", name: "Angola", number: "024" },
  [CountryCode.AI]: { code: "AI", code3: "AIA", name: "Anguilla", number: "660" },
  [CountryCode.AQ]: { code: "AQ", code3: "ATA", name: "Antarctica", number: "010" },
  [CountryCode.AG]: { code: "AG", code3: "ATG", name: "Antigua and Barbuda", number: "028" },
  [CountryCode.AR]: { code: "AR", code3: "ARG", name: "Argentina", number: "032" },
  [CountryCode.AM]: { code: "AM", code3: "ARM", name: "Armenia", number: "051" },
  [CountryCode.AW]: { code: "AW", code3: "ABW", name: "Aruba", number: "533" },
  [CountryCode.AU]: { code: "AU", code3: "AUS", name: "Australia", number: "036" },
  [CountryCode.AT]: { code: "AT", code3: "AUT", name: "Austria", number: "040" },
  [CountryCode.AZ]: { code: "AZ", code3: "AZE", name: "Azerbaijan", number: "031" },
  [CountryCode.BS]: { code: "BS", code3: "BHS", name: "Bahamas (the)", number: "044" },
  [CountryCode.BH]: { code: "BH", code3: "BHR", name: "Bahrain", number: "048" },
  [CountryCode.BD]: { code: "BD", code3: "BGD", name: "Bangladesh", number: "050" },
  [CountryCode.BB]: { code: "BB", code3: "BRB", name: "Barbados", number: "052" },
  [CountryCode.BY]: { code: "BY", code3: "BLR", name: "Belarus", number: "112" },
  [CountryCode.BE]: { code: "BE", code3: "BEL", name: "Belgium", number: "056" },
  [CountryCode.BZ]: { code: "BZ", code3: "BLZ", name: "Belize", number: "084" },
  [CountryCode.BJ]: { code: "BJ", code3: "BEN", name: "Benin", number: "204" },
  [CountryCode.BM]: { code: "BM", code3: "BMU", name: "Bermuda", number: "060" },
  [CountryCode.BT]: { code: "BT", code3: "BTN", name: "Bhutan", number: "064" },
  [CountryCode.BO]: {
    code: "BO",
    code3: "BOL",
    name: "Bolivia (Plurinational State of)",
    number: "068"
  },
  [CountryCode.BQ]: {
    code: "BQ",
    code3: "BES",
    name: "Bonaire, Sint Eustatius and Saba",
    number: "535"
  },
  [CountryCode.BA]: { code: "BA", code3: "BIH", name: "Bosnia and Herzegovina", number: "070" },
  [CountryCode.BW]: { code: "BW", code3: "BWA", name: "Botswana", number: "072" },
  [CountryCode.BV]: { code: "BV", code3: "BVT", name: "Bouvet Island", number: "074" },
  [CountryCode.BR]: { code: "BR", code3: "BRA", name: "Brazil", number: "076" },
  [CountryCode.IO]: {
    code: "IO",
    code3: "IOT",
    name: "British Indian Ocean Territory (the)",
    number: "086"
  },
  [CountryCode.BN]: { code: "BN", code3: "BRN", name: "Brunei Darussalam", number: "096" },
  [CountryCode.BG]: { code: "BG", code3: "BGR", name: "Bulgaria", number: "100" },
  [CountryCode.BF]: { code: "BF", code3: "BFA", name: "Burkina Faso", number: "854" },
  [CountryCode.BI]: { code: "BI", code3: "BDI", name: "Burundi", number: "108" },
  [CountryCode.CV]: { code: "CV", code3: "CPV", name: "Cabo Verde", number: "132" },
  [CountryCode.KH]: { code: "KH", code3: "KHM", name: "Cambodia", number: "116" },
  [CountryCode.CM]: { code: "CM", code3: "CMR", name: "Cameroon", number: "120" },
  [CountryCode.KY]: { code: "KY", code3: "CYM", name: "Cayman Islands (the)", number: "136" },
  [CountryCode.CF]: {
    code: "CF",
    code3: "CAF",
    name: "Central African Republic (the)",
    number: "140"
  },
  [CountryCode.TD]: { code: "TD", code3: "TCD", name: "Chad", number: "148" },
  [CountryCode.CL]: { code: "CL", code3: "CHL", name: "Chile", number: "152" },
  [CountryCode.CN]: { code: "CN", code3: "CHN", name: "China", number: "156" },
  [CountryCode.CX]: { code: "CX", code3: "CXR", name: "Christmas Island", number: "162" },
  [CountryCode.CC]: {
    code: "CC",
    code3: "CCK",
    name: "Cocos (Keeling) Islands (the)",
    number: "166"
  },
  [CountryCode.CO]: { code: "CO", code3: "COL", name: "Colombia", number: "170" },
  [CountryCode.KM]: { code: "KM", code3: "COM", name: "Comoros (the)", number: "174" },
  [CountryCode.CD]: {
    code: "CD",
    code3: "COD",
    name: "Congo (the Democratic Republic of the)",
    number: "180"
  },
  [CountryCode.CG]: { code: "CG", code3: "COG", name: "Congo (the)", number: "178" },
  [CountryCode.CK]: { code: "CK", code3: "COK", name: "Cook Islands (the)", number: "184" },
  [CountryCode.CR]: { code: "CR", code3: "CRI", name: "Costa Rica", number: "188" },
  [CountryCode.HR]: { code: "HR", code3: "HRV", name: "Croatia", number: "191" },
  [CountryCode.CU]: { code: "CU", code3: "CUB", name: "Cuba", number: "192" },
  [CountryCode.CW]: { code: "CW", code3: "CUW", name: "Curaçao", number: "531" },
  [CountryCode.CY]: { code: "CY", code3: "CYP", name: "Cyprus", number: "196" },
  [CountryCode.CZ]: { code: "CZ", code3: "CZE", name: "Czechia", number: "203" },
  [CountryCode.CI]: { code: "CI", code3: "CIV", name: "Côte d'Ivoire", number: "384" },
  [CountryCode.DK]: { code: "DK", code3: "DNK", name: "Denmark", number: "208" },
  [CountryCode.DJ]: { code: "DJ", code3: "DJI", name: "Djibouti", number: "262" },
  [CountryCode.DM]: { code: "DM", code3: "DMA", name: "Dominica", number: "212" },
  [CountryCode.DO]: { code: "DO", code3: "DOM", name: "Dominican Republic (the)", number: "214" },
  [CountryCode.EC]: { code: "EC", code3: "ECU", name: "Ecuador", number: "218" },
  [CountryCode.EG]: { code: "EG", code3: "EGY", name: "Egypt", number: "818" },
  [CountryCode.SV]: { code: "SV", code3: "SLV", name: "El Salvador", number: "222" },
  [CountryCode.GQ]: { code: "GQ", code3: "GNQ", name: "Equatorial Guinea", number: "226" },
  [CountryCode.ER]: { code: "ER", code3: "ERI", name: "Eritrea", number: "232" },
  [CountryCode.EE]: { code: "EE", code3: "EST", name: "Estonia", number: "233" },
  [CountryCode.SZ]: { code: "SZ", code3: "SWZ", name: "Eswatini", number: "748" },
  [CountryCode.ET]: { code: "ET", code3: "ETH", name: "Ethiopia", number: "231" },
  [CountryCode.FK]: {
    code: "FK",
    code3: "FLK",
    name: "Falkland Islands (the) [Malvinas]",
    number: "238"
  },
  [CountryCode.FO]: { code: "FO", code3: "FRO", name: "Faroe Islands (the)", number: "234" },
  [CountryCode.FJ]: { code: "FJ", code3: "FJI", name: "Fiji", number: "242" },
  [CountryCode.FI]: { code: "FI", code3: "FIN", name: "Finland", number: "246" },
  [CountryCode.FR]: { code: "FR", code3: "FRA", name: "France", number: "250" },
  [CountryCode.GF]: { code: "GF", code3: "GUF", name: "French Guiana", number: "254" },
  [CountryCode.PF]: { code: "PF", code3: "PYF", name: "French Polynesia", number: "258" },
  [CountryCode.TF]: {
    code: "TF",
    code3: "ATF",
    name: "French Southern Territories (the)",
    number: "260"
  },
  [CountryCode.GA]: { code: "GA", code3: "GAB", name: "Gabon", number: "266" },
  [CountryCode.GM]: { code: "GM", code3: "GMB", name: "Gambia (the)", number: "270" },
  [CountryCode.GE]: { code: "GE", code3: "GEO", name: "Georgia", number: "268" },
  [CountryCode.DE]: { code: "DE", code3: "DEU", name: "Germany", number: "276" },
  [CountryCode.GH]: { code: "GH", code3: "GHA", name: "Ghana", number: "288" },
  [CountryCode.GI]: { code: "GI", code3: "GIB", name: "Gibraltar", number: "292" },
  [CountryCode.GR]: { code: "GR", code3: "GRC", name: "Greece", number: "300" },
  [CountryCode.GL]: { code: "GL", code3: "GRL", name: "Greenland", number: "304" },
  [CountryCode.GD]: { code: "GD", code3: "GRD", name: "Grenada", number: "308" },
  [CountryCode.GP]: { code: "GP", code3: "GLP", name: "Guadeloupe", number: "312" },
  [CountryCode.GU]: { code: "GU", code3: "GUM", name: "Guam", number: "316" },
  [CountryCode.GT]: { code: "GT", code3: "GTM", name: "Guatemala", number: "320" },
  [CountryCode.GG]: { code: "GG", code3: "GGY", name: "Guernsey", number: "831" },
  [CountryCode.GN]: { code: "GN", code3: "GIN", name: "Guinea", number: "324" },
  [CountryCode.GW]: { code: "GW", code3: "GNB", name: "Guinea-Bissau", number: "624" },
  [CountryCode.GY]: { code: "GY", code3: "GUY", name: "Guyana", number: "328" },
  [CountryCode.HT]: { code: "HT", code3: "HTI", name: "Haiti", number: "332" },
  [CountryCode.HM]: {
    code: "HM",
    code3: "HMD",
    name: "Heard Island and McDonald Islands",
    number: "334"
  },
  [CountryCode.VA]: { code: "VA", code3: "VAT", name: "Holy See (the)", number: "336" },
  [CountryCode.HN]: { code: "HN", code3: "HND", name: "Honduras", number: "340" },
  [CountryCode.HK]: { code: "HK", code3: "HKG", name: "Hong Kong", number: "344" },
  [CountryCode.HU]: { code: "HU", code3: "HUN", name: "Hungary", number: "348" },
  [CountryCode.IS]: { code: "IS", code3: "ISL", name: "Iceland", number: "352" },
  [CountryCode.IN]: { code: "IN", code3: "IND", name: "India", number: "356" },
  [CountryCode.ID]: { code: "ID", code3: "IDN", name: "Indonesia", number: "360" },
  [CountryCode.IR]: { code: "IR", code3: "IRN", name: "Iran (Islamic Republic of)", number: "364" },
  [CountryCode.IQ]: { code: "IQ", code3: "IRQ", name: "Iraq", number: "368" },
  [CountryCode.IE]: { code: "IE", code3: "IRL", name: "Ireland", number: "372" },
  [CountryCode.IM]: { code: "IM", code3: "IMN", name: "Isle of Man", number: "833" },
  [CountryCode.IL]: { code: "IL", code3: "ISR", name: "Israel", number: "376" },
  [CountryCode.IT]: { code: "IT", code3: "ITA", name: "Italy", number: "380" },
  [CountryCode.JM]: { code: "JM", code3: "JAM", name: "Jamaica", number: "388" },
  [CountryCode.JP]: { code: "JP", code3: "JPN", name: "Japan", number: "392" },
  [CountryCode.JE]: { code: "JE", code3: "JEY", name: "Jersey", number: "832" },
  [CountryCode.JO]: { code: "JO", code3: "JOR", name: "Jordan", number: "400" },
  [CountryCode.KZ]: { code: "KZ", code3: "KAZ", name: "Kazakhstan", number: "398" },
  [CountryCode.KE]: { code: "KE", code3: "KEN", name: "Kenya", number: "404" },
  [CountryCode.KI]: { code: "KI", code3: "KIR", name: "Kiribati", number: "296" },
  [CountryCode.KP]: {
    code: "KP",
    code3: "PRK",
    name: "Korea (the Democratic People's Republic of)",
    number: "408"
  },
  [CountryCode.KR]: { code: "KR", code3: "KOR", name: "Korea (the Republic of)", number: "410" },
  [CountryCode.KW]: { code: "KW", code3: "KWT", name: "Kuwait", number: "414" },
  [CountryCode.KG]: { code: "KG", code3: "KGZ", name: "Kyrgyzstan", number: "417" },
  [CountryCode.LA]: {
    code: "LA",
    code3: "LAO",
    name: "Lao People's Democratic Republic (the)",
    number: "418"
  },
  [CountryCode.LV]: { code: "LV", code3: "LVA", name: "Latvia", number: "428" },
  [CountryCode.LB]: { code: "LB", code3: "LBN", name: "Lebanon", number: "422" },
  [CountryCode.LS]: { code: "LS", code3: "LSO", name: "Lesotho", number: "426" },
  [CountryCode.LR]: { code: "LR", code3: "LBR", name: "Liberia", number: "430" },
  [CountryCode.LY]: { code: "LY", code3: "LBY", name: "Libya", number: "434" },
  [CountryCode.LI]: { code: "LI", code3: "LIE", name: "Liechtenstein", number: "438" },
  [CountryCode.LT]: { code: "LT", code3: "LTU", name: "Lithuania", number: "440" },
  [CountryCode.LU]: { code: "LU", code3: "LUX", name: "Luxembourg", number: "442" },
  [CountryCode.MO]: { code: "MO", code3: "MAC", name: "Macao", number: "446" },
  [CountryCode.MG]: { code: "MG", code3: "MDG", name: "Madagascar", number: "450" },
  [CountryCode.MW]: { code: "MW", code3: "MWI", name: "Malawi", number: "454" },
  [CountryCode.MY]: { code: "MY", code3: "MYS", name: "Malaysia", number: "458" },
  [CountryCode.MV]: { code: "MV", code3: "MDV", name: "Maldives", number: "462" },
  [CountryCode.ML]: { code: "ML", code3: "MLI", name: "Mali", number: "466" },
  [CountryCode.MT]: { code: "MT", code3: "MLT", name: "Malta", number: "470" },
  [CountryCode.MH]: { code: "MH", code3: "MHL", name: "Marshall Islands (the)", number: "584" },
  [CountryCode.MQ]: { code: "MQ", code3: "MTQ", name: "Martinique", number: "474" },
  [CountryCode.MR]: { code: "MR", code3: "MRT", name: "Mauritania", number: "478" },
  [CountryCode.MU]: { code: "MU", code3: "MUS", name: "Mauritius", number: "480" },
  [CountryCode.YT]: { code: "YT", code3: "MYT", name: "Mayotte", number: "175" },
  [CountryCode.MX]: { code: "MX", code3: "MEX", name: "Mexico", number: "484" },
  [CountryCode.FM]: {
    code: "FM",
    code3: "FSM",
    name: "Micronesia (Federated States of)",
    number: "583"
  },
  [CountryCode.MD]: { code: "MD", code3: "MDA", name: "Moldova (the Republic of)", number: "498" },
  [CountryCode.MC]: { code: "MC", code3: "MCO", name: "Monaco", number: "492" },
  [CountryCode.MN]: { code: "MN", code3: "MNG", name: "Mongolia", number: "496" },
  [CountryCode.ME]: { code: "ME", code3: "MNE", name: "Montenegro", number: "499" },
  [CountryCode.MS]: { code: "MS", code3: "MSR", name: "Montserrat", number: "500" },
  [CountryCode.MA]: { code: "MA", code3: "MAR", name: "Morocco", number: "504" },
  [CountryCode.MZ]: { code: "MZ", code3: "MOZ", name: "Mozambique", number: "508" },
  [CountryCode.MM]: { code: "MM", code3: "MMR", name: "Myanmar", number: "104" },
  [CountryCode.NA]: { code: "NA", code3: "NAM", name: "Namibia", number: "516" },
  [CountryCode.NR]: { code: "NR", code3: "NRU", name: "Nauru", number: "520" },
  [CountryCode.NP]: { code: "NP", code3: "NPL", name: "Nepal", number: "524" },
  [CountryCode.NL]: { code: "NL", code3: "NLD", name: "Netherlands (the)", number: "528" },
  [CountryCode.NC]: { code: "NC", code3: "NCL", name: "New Caledonia", number: "540" },
  [CountryCode.NZ]: { code: "NZ", code3: "NZL", name: "New Zealand", number: "554" },
  [CountryCode.NI]: { code: "NI", code3: "NIC", name: "Nicaragua", number: "558" },
  [CountryCode.NE]: { code: "NE", code3: "NER", name: "Niger (the)", number: "562" },
  [CountryCode.NG]: { code: "NG", code3: "NGA", name: "Nigeria", number: "566" },
  [CountryCode.NU]: { code: "NU", code3: "NIU", name: "Niue", number: "570" },
  [CountryCode.NF]: { code: "NF", code3: "NFK", name: "Norfolk Island", number: "574" },
  [CountryCode.MP]: {
    code: "MP",
    code3: "MNP",
    name: "Northern Mariana Islands (the)",
    number: "580"
  },
  [CountryCode.NO]: { code: "NO", code3: "NOR", name: "Norway", number: "578" },
  [CountryCode.OM]: { code: "OM", code3: "OMN", name: "Oman", number: "512" },
  [CountryCode.PK]: { code: "PK", code3: "PAK", name: "Pakistan", number: "586" },
  [CountryCode.PW]: { code: "PW", code3: "PLW", name: "Palau", number: "585" },
  [CountryCode.PS]: { code: "PS", code3: "PSE", name: "Palestine, State of", number: "275" },
  [CountryCode.PA]: { code: "PA", code3: "PAN", name: "Panama", number: "591" },
  [CountryCode.PG]: { code: "PG", code3: "PNG", name: "Papua New Guinea", number: "598" },
  [CountryCode.PY]: { code: "PY", code3: "PRY", name: "Paraguay", number: "600" },
  [CountryCode.PE]: { code: "PE", code3: "PER", name: "Peru", number: "604" },
  [CountryCode.PH]: { code: "PH", code3: "PHL", name: "Philippines (the)", number: "608" },
  [CountryCode.PN]: { code: "PN", code3: "PCN", name: "Pitcairn", number: "612" },
  [CountryCode.PL]: { code: "PL", code3: "POL", name: "Poland", number: "616" },
  [CountryCode.PT]: { code: "PT", code3: "PRT", name: "Portugal", number: "620" },
  [CountryCode.PR]: { code: "PR", code3: "PRI", name: "Puerto Rico", number: "630" },
  [CountryCode.QA]: { code: "QA", code3: "QAT", name: "Qatar", number: "634" },
  [CountryCode.MK]: {
    code: "MK",
    code3: "MKD",
    name: "Republic of North Macedonia",
    number: "807"
  },
  [CountryCode.RO]: { code: "RO", code3: "ROU", name: "Romania", number: "642" },
  [CountryCode.RU]: { code: "RU", code3: "RUS", name: "Russian Federation (the)", number: "643" },
  [CountryCode.RW]: { code: "RW", code3: "RWA", name: "Rwanda", number: "646" },
  [CountryCode.RE]: { code: "RE", code3: "REU", name: "Réunion", number: "638" },
  [CountryCode.BL]: { code: "BL", code3: "BLM", name: "Saint Barthélemy", number: "652" },
  [CountryCode.SH]: {
    code: "SH",
    code3: "SHN",
    name: "Saint Helena, Ascension and Tristan da Cunha",
    number: "654"
  },
  [CountryCode.KN]: { code: "KN", code3: "KNA", name: "Saint Kitts and Nevis", number: "659" },
  [CountryCode.LC]: { code: "LC", code3: "LCA", name: "Saint Lucia", number: "662" },
  [CountryCode.MF]: { code: "MF", code3: "MAF", name: "Saint Martin (French part)", number: "663" },
  [CountryCode.PM]: { code: "PM", code3: "SPM", name: "Saint Pierre and Miquelon", number: "666" },
  [CountryCode.VC]: {
    code: "VC",
    code3: "VCT",
    name: "Saint Vincent and the Grenadines",
    number: "670"
  },
  [CountryCode.WS]: { code: "WS", code3: "WSM", name: "Samoa", number: "882" },
  [CountryCode.SM]: { code: "SM", code3: "SMR", name: "San Marino", number: "674" },
  [CountryCode.ST]: { code: "ST", code3: "STP", name: "Sao Tome and Principe", number: "678" },
  [CountryCode.SA]: { code: "SA", code3: "SAU", name: "Saudi Arabia", number: "682" },
  [CountryCode.SN]: { code: "SN", code3: "SEN", name: "Senegal", number: "686" },
  [CountryCode.RS]: { code: "RS", code3: "SRB", name: "Serbia", number: "688" },
  [CountryCode.SC]: { code: "SC", code3: "SYC", name: "Seychelles", number: "690" },
  [CountryCode.SL]: { code: "SL", code3: "SLE", name: "Sierra Leone", number: "694" },
  [CountryCode.SG]: { code: "SG", code3: "SGP", name: "Singapore", number: "702" },
  [CountryCode.SX]: { code: "SX", code3: "SXM", name: "Sint Maarten (Dutch part)", number: "534" },
  [CountryCode.SK]: { code: "SK", code3: "SVK", name: "Slovakia", number: "703" },
  [CountryCode.SI]: { code: "SI", code3: "SVN", name: "Slovenia", number: "705" },
  [CountryCode.SB]: { code: "SB", code3: "SLB", name: "Solomon Islands", number: "090" },
  [CountryCode.SO]: { code: "SO", code3: "SOM", name: "Somalia", number: "706" },
  [CountryCode.ZA]: { code: "ZA", code3: "ZAF", name: "South Africa", number: "710" },
  [CountryCode.GS]: {
    code: "GS",
    code3: "SGS",
    name: "South Georgia and the South Sandwich Islands",
    number: "239"
  },
  [CountryCode.SS]: { code: "SS", code3: "SSD", name: "South Sudan", number: "728" },
  [CountryCode.ES]: { code: "ES", code3: "ESP", name: "Spain", number: "724" },
  [CountryCode.LK]: { code: "LK", code3: "LKA", name: "Sri Lanka", number: "144" },
  [CountryCode.SD]: { code: "SD", code3: "SDN", name: "Sudan (the)", number: "729" },
  [CountryCode.SR]: { code: "SR", code3: "SUR", name: "Suriname", number: "740" },
  [CountryCode.SJ]: { code: "SJ", code3: "SJM", name: "Svalbard and Jan Mayen", number: "744" },
  [CountryCode.SE]: { code: "SE", code3: "SWE", name: "Sweden", number: "752" },
  [CountryCode.CH]: { code: "CH", code3: "CHE", name: "Switzerland", number: "756" },
  [CountryCode.SY]: { code: "SY", code3: "SYR", name: "Syrian Arab Republic", number: "760" },
  [CountryCode.TW]: { code: "TW", code3: "TWN", name: "Taiwan", number: "158" },
  [CountryCode.TJ]: { code: "TJ", code3: "TJK", name: "Tajikistan", number: "762" },
  [CountryCode.TZ]: {
    code: "TZ",
    code3: "TZA",
    name: "Tanzania, United Republic of",
    number: "834"
  },
  [CountryCode.TH]: { code: "TH", code3: "THA", name: "Thailand", number: "764" },
  [CountryCode.TL]: { code: "TL", code3: "TLS", name: "Timor-Leste", number: "626" },
  [CountryCode.TG]: { code: "TG", code3: "TGO", name: "Togo", number: "768" },
  [CountryCode.TK]: { code: "TK", code3: "TKL", name: "Tokelau", number: "772" },
  [CountryCode.TO]: { code: "TO", code3: "TON", name: "Tonga", number: "776" },
  [CountryCode.TT]: { code: "TT", code3: "TTO", name: "Trinidad and Tobago", number: "780" },
  [CountryCode.TN]: { code: "TN", code3: "TUN", name: "Tunisia", number: "788" },
  [CountryCode.TR]: { code: "TR", code3: "TUR", name: "Turkey", number: "792" },
  [CountryCode.TM]: { code: "TM", code3: "TKM", name: "Turkmenistan", number: "795" },
  [CountryCode.TC]: {
    code: "TC",
    code3: "TCA",
    name: "Turks and Caicos Islands (the)",
    number: "796"
  },
  [CountryCode.TV]: { code: "TV", code3: "TUV", name: "Tuvalu", number: "798" },
  [CountryCode.UG]: { code: "UG", code3: "UGA", name: "Uganda", number: "800" },
  [CountryCode.UA]: { code: "UA", code3: "UKR", name: "Ukraine", number: "804" },
  [CountryCode.AE]: { code: "AE", code3: "ARE", name: "United Arab Emirates (the)", number: "784" },
  [CountryCode.GB]: {
    code: "GB",
    code3: "GBR",
    name: "United Kingdom of Great Britain and Northern Ireland (the)",
    number: "826"
  },
  [CountryCode.UM]: {
    code: "UM",
    code3: "UMI",
    name: "United States Minor Outlying Islands (the)",
    number: "581"
  },
  [CountryCode.UY]: { code: "UY", code3: "URY", name: "Uruguay", number: "858" },
  [CountryCode.UZ]: { code: "UZ", code3: "UZB", name: "Uzbekistan", number: "860" },
  [CountryCode.VU]: { code: "VU", code3: "VUT", name: "Vanuatu", number: "548" },
  [CountryCode.VE]: {
    code: "VE",
    code3: "VEN",
    name: "Venezuela (Bolivarian Republic of)",
    number: "862"
  },
  [CountryCode.VN]: { code: "VN", code3: "VNM", name: "Viet Nam", number: "704" },
  [CountryCode.VG]: { code: "VG", code3: "VGB", name: "Virgin Islands (British)", number: "092" },
  [CountryCode.VI]: { code: "VI", code3: "VIR", name: "Virgin Islands (U.S.)", number: "850" },
  [CountryCode.WF]: { code: "WF", code3: "WLF", name: "Wallis and Futuna", number: "876" },
  [CountryCode.EH]: { code: "EH", code3: "ESH", name: "Western Sahara", number: "732" },
  [CountryCode.YE]: { code: "YE", code3: "YEM", name: "Yemen", number: "887" },
  [CountryCode.ZM]: { code: "ZM", code3: "ZMB", name: "Zambia", number: "894" },
  [CountryCode.ZW]: { code: "ZW", code3: "ZWE", name: "Zimbabwe", number: "716" },
  [CountryCode.AX]: { code: "AX", code3: "ALA", name: "Åland Islands", number: "248" }
};

export const CountryCodeNameMap = {
  [CountryName.UnitedStates]: CountryCode.US,
  [CountryName.USA]: CountryCode.US,
  [CountryName.US]: CountryCode.US,
  [CountryName.Canada]: CountryCode.CA,
  [CountryName.Afghanistan]: CountryCode.AF,
  [CountryName.Albania]: CountryCode.AL,
  [CountryName.Algeria]: CountryCode.DZ,
  [CountryName.AmericanSamoa]: CountryCode.AS,
  [CountryName.Andorra]: CountryCode.AD,
  [CountryName.Angola]: CountryCode.AO,
  [CountryName.Anguilla]: CountryCode.AI,
  [CountryName.Antarctica]: CountryCode.AQ,
  [CountryName.AntiguaAndBarbuda]: CountryCode.AG,
  [CountryName.Argentina]: CountryCode.AR,
  [CountryName.Armenia]: CountryCode.AM,
  [CountryName.Aruba]: CountryCode.AW,
  [CountryName.Australia]: CountryCode.AU,
  [CountryName.Austria]: CountryCode.AT,
  [CountryName.Azerbaijan]: CountryCode.AZ,
  [CountryName.Bahamas]: CountryCode.BS,
  [CountryName.Bahrain]: CountryCode.BH,
  [CountryName.Bangladesh]: CountryCode.BD,
  [CountryName.Barbados]: CountryCode.BB,
  [CountryName.Belarus]: CountryCode.BY,
  [CountryName.Belgium]: CountryCode.BE,
  [CountryName.Belize]: CountryCode.BZ,
  [CountryName.Benin]: CountryCode.BJ,
  [CountryName.Bermuda]: CountryCode.BM,
  [CountryName.Bhutan]: CountryCode.BT,
  [CountryName.Bolivia]: CountryCode.BO,
  [CountryName.BonaireSintEustatiusAndSaba]: CountryCode.BQ,
  [CountryName.BosniaAndHerzegovina]: CountryCode.BA,
  [CountryName.Botswana]: CountryCode.BW,
  [CountryName.BouvetIsland]: CountryCode.BV,
  [CountryName.Brazil]: CountryCode.BR,
  [CountryName.BritishIndianOceanTerritory]: CountryCode.IO,
  [CountryName.BruneiDarussalam]: CountryCode.BN,
  [CountryName.Bulgaria]: CountryCode.BG,
  [CountryName.BurkinaFaso]: CountryCode.BF,
  [CountryName.Burundi]: CountryCode.BI,
  [CountryName.CaboVerde]: CountryCode.CV,
  [CountryName.Cambodia]: CountryCode.KH,
  [CountryName.Cameroon]: CountryCode.CM,
  [CountryName.CaymanIslands]: CountryCode.KY,
  [CountryName.CentralAfricanRepublic]: CountryCode.CF,
  [CountryName.Chad]: CountryCode.TD,
  [CountryName.Chile]: CountryCode.CL,
  [CountryName.China]: CountryCode.CN,
  [CountryName.ChristmasIsland]: CountryCode.CX,
  [CountryName.CocosKeelingIslands]: CountryCode.CC,
  [CountryName.Colombia]: CountryCode.CO,
  [CountryName.Comoros]: CountryCode.KM,
  [CountryName.CongoDemocraticRepublic]: CountryCode.CD,
  [CountryName.Congo]: CountryCode.CG,
  [CountryName.CookIslands]: CountryCode.CK,
  [CountryName.CostaRica]: CountryCode.CR,
  [CountryName.Croatia]: CountryCode.HR,
  [CountryName.Cuba]: CountryCode.CU,
  [CountryName.Curacao]: CountryCode.CW,
  [CountryName.Cyprus]: CountryCode.CY,
  [CountryName.Czechia]: CountryCode.CZ,
  [CountryName.CoteDIvoire]: CountryCode.CI,
  [CountryName.Denmark]: CountryCode.DK,
  [CountryName.Djibouti]: CountryCode.DJ,
  [CountryName.Dominica]: CountryCode.DM,
  [CountryName.DominicanRepublic]: CountryCode.DO,
  [CountryName.Ecuador]: CountryCode.EC,
  [CountryName.Egypt]: CountryCode.EG,
  [CountryName.ElSalvador]: CountryCode.SV,
  [CountryName.EquatorialGuinea]: CountryCode.GQ,
  [CountryName.Eritrea]: CountryCode.ER,
  [CountryName.Estonia]: CountryCode.EE,
  [CountryName.Eswatini]: CountryCode.SZ,
  [CountryName.Ethiopia]: CountryCode.ET,
  [CountryName.FalklandIslands]: CountryCode.FK,
  [CountryName.FaroeIslands]: CountryCode.FO,
  [CountryName.Fiji]: CountryCode.FJ,
  [CountryName.Finland]: CountryCode.FI,
  [CountryName.France]: CountryCode.FR,
  [CountryName.FrenchGuiana]: CountryCode.GF,
  [CountryName.FrenchPolynesia]: CountryCode.PF,
  [CountryName.FrenchSouthernTerritories]: CountryCode.TF,
  [CountryName.Gabon]: CountryCode.GA,
  [CountryName.Gambia]: CountryCode.GM,
  [CountryName.Georgia]: CountryCode.GE,
  [CountryName.Germany]: CountryCode.DE,
  [CountryName.Ghana]: CountryCode.GH,
  [CountryName.Gibraltar]: CountryCode.GI,
  [CountryName.Greece]: CountryCode.GR,
  [CountryName.Greenland]: CountryCode.GL,
  [CountryName.Grenada]: CountryCode.GD,
  [CountryName.Guadeloupe]: CountryCode.GP,
  [CountryName.Guam]: CountryCode.GU,
  [CountryName.Guatemala]: CountryCode.GT,
  [CountryName.Guernsey]: CountryCode.GG,
  [CountryName.Guinea]: CountryCode.GN,
  [CountryName.GuineaBissau]: CountryCode.GW,
  [CountryName.Guyana]: CountryCode.GY,
  [CountryName.Haiti]: CountryCode.HT,
  [CountryName.HeardIslandAndMcDonaldIslands]: CountryCode.HM,
  [CountryName.HolySee]: CountryCode.VA,
  [CountryName.Honduras]: CountryCode.HN,
  [CountryName.HongKong]: CountryCode.HK,
  [CountryName.Hungary]: CountryCode.HU,
  [CountryName.Iceland]: CountryCode.IS,
  [CountryName.India]: CountryCode.IN,
  [CountryName.Indonesia]: CountryCode.ID,
  [CountryName.Iran]: CountryCode.IR,
  [CountryName.Iraq]: CountryCode.IQ,
  [CountryName.Ireland]: CountryCode.IE,
  [CountryName.IsleOfMan]: CountryCode.IM,
  [CountryName.Israel]: CountryCode.IL,
  [CountryName.Italy]: CountryCode.IT,
  [CountryName.Jamaica]: CountryCode.JM,
  [CountryName.Japan]: CountryCode.JP,
  [CountryName.Jersey]: CountryCode.JE,
  [CountryName.Jordan]: CountryCode.JO,
  [CountryName.Kazakhstan]: CountryCode.KZ,
  [CountryName.Kenya]: CountryCode.KE,
  [CountryName.Kiribati]: CountryCode.KI,
  [CountryName.KoreaDemocraticPeoplesRepublic]: CountryCode.KP,
  [CountryName.KoreaRepublic]: CountryCode.KR,
  [CountryName.Kuwait]: CountryCode.KW,
  [CountryName.Kyrgyzstan]: CountryCode.KG,
  [CountryName.LaoPeoplesDemocraticRepublic]: CountryCode.LA,
  [CountryName.Latvia]: CountryCode.LV,
  [CountryName.Lebanon]: CountryCode.LB,
  [CountryName.Lesotho]: CountryCode.LS,
  [CountryName.Liberia]: CountryCode.LR,
  [CountryName.Libya]: CountryCode.LY,
  [CountryName.Liechtenstein]: CountryCode.LI,
  [CountryName.Lithuania]: CountryCode.LT,
  [CountryName.Luxembourg]: CountryCode.LU,
  [CountryName.Macao]: CountryCode.MO,
  [CountryName.Madagascar]: CountryCode.MG,
  [CountryName.Malawi]: CountryCode.MW,
  [CountryName.Malaysia]: CountryCode.MY,
  [CountryName.Maldives]: CountryCode.MV,
  [CountryName.Mali]: CountryCode.ML,
  [CountryName.Malta]: CountryCode.MT,
  [CountryName.MarshallIslands]: CountryCode.MH,
  [CountryName.Martinique]: CountryCode.MQ,
  [CountryName.Mauritania]: CountryCode.MR,
  [CountryName.Mauritius]: CountryCode.MU,
  [CountryName.Mayotte]: CountryCode.YT,
  [CountryName.Mexico]: CountryCode.MX,
  [CountryName.Micronesia]: CountryCode.FM,
  [CountryName.Moldova]: CountryCode.MD,
  [CountryName.Monaco]: CountryCode.MC,
  [CountryName.Mongolia]: CountryCode.MN,
  [CountryName.Montenegro]: CountryCode.ME,
  [CountryName.Montserrat]: CountryCode.MS,
  [CountryName.Morocco]: CountryCode.MA,
  [CountryName.Mozambique]: CountryCode.MZ,
  [CountryName.Myanmar]: CountryCode.MM,
  [CountryName.Namibia]: CountryCode.NA,
  [CountryName.Nauru]: CountryCode.NR,
  [CountryName.Nepal]: CountryCode.NP,
  [CountryName.Netherlands]: CountryCode.NL,
  [CountryName.NewCaledonia]: CountryCode.NC,
  [CountryName.NewZealand]: CountryCode.NZ,
  [CountryName.Nicaragua]: CountryCode.NI,
  [CountryName.Niger]: CountryCode.NE,
  [CountryName.Nigeria]: CountryCode.NG,
  [CountryName.Niue]: CountryCode.NU,
  [CountryName.NorfolkIsland]: CountryCode.NF,
  [CountryName.NorthernMarianaIslands]: CountryCode.MP,
  [CountryName.Norway]: CountryCode.NO,
  [CountryName.Oman]: CountryCode.OM,
  [CountryName.Pakistan]: CountryCode.PK,
  [CountryName.Palau]: CountryCode.PW,
  [CountryName.PalestineState]: CountryCode.PS,
  [CountryName.Panama]: CountryCode.PA,
  [CountryName.PapuaNewGuinea]: CountryCode.PG,
  [CountryName.Paraguay]: CountryCode.PY,
  [CountryName.Peru]: CountryCode.PE,
  [CountryName.Philippines]: CountryCode.PH,
  [CountryName.Pitcairn]: CountryCode.PN,
  [CountryName.Poland]: CountryCode.PL,
  [CountryName.Portugal]: CountryCode.PT,
  [CountryName.PuertoRico]: CountryCode.PR,
  [CountryName.Qatar]: CountryCode.QA,
  [CountryName.RepublicOfNorthMacedonia]: CountryCode.MK,
  [CountryName.Romania]: CountryCode.RO,
  [CountryName.RussianFederation]: CountryCode.RU,
  [CountryName.Rwanda]: CountryCode.RW,
  [CountryName.Reunion]: CountryCode.RE,
  [CountryName.SaintBarthelemy]: CountryCode.BL,
  [CountryName.SaintHelenaAscensionAndTristanDaCunha]: CountryCode.SH,
  [CountryName.SaintKittsAndNevis]: CountryCode.KN,
  [CountryName.SaintLucia]: CountryCode.LC,
  [CountryName.SaintMartinFrenchPart]: CountryCode.MF,
  [CountryName.SaintPierreAndMiquelon]: CountryCode.PM,
  [CountryName.SaintVincentAndTheGrenadines]: CountryCode.VC,
  [CountryName.Samoa]: CountryCode.WS,
  [CountryName.SanMarino]: CountryCode.SM,
  [CountryName.SaoTomeAndPrincipe]: CountryCode.ST,
  [CountryName.SaudiArabia]: CountryCode.SA,
  [CountryName.Senegal]: CountryCode.SN,
  [CountryName.Serbia]: CountryCode.RS,
  [CountryName.Seychelles]: CountryCode.SC,
  [CountryName.SierraLeone]: CountryCode.SL,
  [CountryName.Singapore]: CountryCode.SG,
  [CountryName.SintMaartenDutchPart]: CountryCode.SX,
  [CountryName.Slovakia]: CountryCode.SK,
  [CountryName.Slovenia]: CountryCode.SI,
  [CountryName.SolomonIslands]: CountryCode.SB,
  [CountryName.Somalia]: CountryCode.SO,
  [CountryName.SouthAfrica]: CountryCode.ZA,
  [CountryName.SouthGeorgiaAndTheSouthSandwichIslands]: CountryCode.GS,
  [CountryName.SouthSudan]: CountryCode.SS,
  [CountryName.Spain]: CountryCode.ES,
  [CountryName.SriLanka]: CountryCode.LK,
  [CountryName.Sudan]: CountryCode.SD,
  [CountryName.Suriname]: CountryCode.SR,
  [CountryName.SvalbardAndJanMayen]: CountryCode.SJ,
  [CountryName.Sweden]: CountryCode.SE,
  [CountryName.Switzerland]: CountryCode.CH,
  [CountryName.SyrianArabRepublic]: CountryCode.SY,
  [CountryName.Taiwan]: CountryCode.TW,
  [CountryName.Tajikistan]: CountryCode.TJ,
  [CountryName.Tanzania]: CountryCode.TZ,
  [CountryName.Thailand]: CountryCode.TH,
  [CountryName.TimorLeste]: CountryCode.TL,
  [CountryName.Togo]: CountryCode.TG,
  [CountryName.Tokelau]: CountryCode.TK,
  [CountryName.Tonga]: CountryCode.TO,
  [CountryName.TrinidadAndTobago]: CountryCode.TT,
  [CountryName.Tunisia]: CountryCode.TN,
  [CountryName.Turkey]: CountryCode.TR,
  [CountryName.Turkmenistan]: CountryCode.TM,
  [CountryName.TurksAndCaicosIslands]: CountryCode.TC,
  [CountryName.Tuvalu]: CountryCode.TV,
  [CountryName.Uganda]: CountryCode.UG,
  [CountryName.Ukraine]: CountryCode.UA,
  [CountryName.UnitedArabEmirates]: CountryCode.AE,
  [CountryName.UnitedKingdom]: CountryCode.GB,
  [CountryName.UnitedStatesMinorOutlyingIslands]: CountryCode.UM,
  [CountryName.Uruguay]: CountryCode.UY,
  [CountryName.Uzbekistan]: CountryCode.UZ,
  [CountryName.Vanuatu]: CountryCode.VU,
  [CountryName.Venezuela]: CountryCode.VE,
  [CountryName.VietNam]: CountryCode.VN,
  [CountryName.VirginIslandsBritish]: CountryCode.VG,
  [CountryName.VirginIslandsUS]: CountryCode.VI,
  [CountryName.WallisAndFutuna]: CountryCode.WF,
  [CountryName.WesternSahara]: CountryCode.EH,
  [CountryName.Yemen]: CountryCode.YE,
  [CountryName.Zambia]: CountryCode.ZM,
  [CountryName.Zimbabwe]: CountryCode.ZW,
  [CountryName.AlandIslands]: CountryCode.AX
};
